var Afghanistan = "أفغانستان";
var Albania = "ألبانيا";
var Algeria = "الجزائر";
var Andorra = "أندورا";
var Angola = "أنجولا";
var Anguilla = "أنجويلا";
var Antarctica = "أنتاركتيكا";
var Argentina = "الأرجنتين";
var Armenia = "أرمينيا";
var Aruba = "أروبا";
var Australia = "أستراليا";
var Austria = "النمسا";
var Azerbaijan = "أذربيجان";
var Bahamas = "جزر البهاما";
var Bahrain = "البحرين";
var Bangladesh = "بنغلاديش";
var Barbados = "باربادوس";
var Belarus = "بيلاروسيا";
var Belgium = "بلجيكا";
var Belize = "بيليز";
var Benin = "بنين";
var Bermuda = "برمودا";
var Bhutan = "بوتان";
var Bolivia = "بوليفيا";
var Botswana = "بوتسوانا";
var Brazil = "البرازيل";
var Bulgaria = "بلغاريا";
var Burundi = "بوروندي";
var Cambodia = "كمبوديا";
var Cameroon = "الكاميرون";
var Canada = "كندا";
var Chad = "تشاد";
var Chile = "تشيلي";
var China = "الصين";
var Colombia = "كولومبيا";
var Comoros = "جزر القمر";
var Congo = "الكونغو";
var Croatia = "كرواتيا";
var Cuba = "كوبا";
var Cyprus = "قبرص";
var Denmark = "الدنمارك";
var Djibouti = "جيبوتي";
var Dominica = "دومينيكا";
var Ecuador = "الإكوادور";
var Egypt = "مصر";
var Eritrea = "إريتريا";
var Estonia = "إستونيا";
var Ethiopia = "إثيوبيا";
var Fiji = "فيجي";
var Finland = "فنلندا";
var France = "فرنسا";
var Gabon = "الجابون";
var Gambia = "جامبيا";
var Georgia = "جورجيا";
var Germany = "ألمانيا";
var Ghana = "غانا";
var Gibraltar = "جبل طارق";
var Greece = "اليونان";
var Greenland = "جرينلاند";
var Grenada = "غرينادا";
var Guadeloupe = "غوادلوب";
var Guam = "غوام";
var Guatemala = "جواتيمالا";
var Guernsey = "غيرنزي";
var Guinea = "غينيا";
var Guyana = "غويانا";
var Haiti = "هاييتي";
var Honduras = "هندوراس";
var Hungary = "المجر";
var Iceland = "أيسلندا";
var India = "الهند";
var Indonesia = "إندونيسيا";
var Iraq = "العراق";
var Ireland = "أيرلندا";
var Israel = "إسرائيل";
var Italy = "إيطاليا";
var Jamaica = "جامايكا";
var Japan = "اليابان";
var Jersey = "جيرزي";
var Jordan = "الأردن";
var Kazakhstan = "كازاخستان";
var Kenya = "كينيا";
var Kiribati = "كيريباتي";
var Kuwait = "الكويت";
var Kyrgyzstan = "قيرغيزستان";
var Latvia = "لاتفيا";
var Lebanon = "لبنان";
var Lesotho = "ليسوتو";
var Liberia = "ليبيريا";
var Libya = "ليبيا";
var Liechtenstein = "ليختنشتاين";
var Lithuania = "ليتوانيا";
var Luxembourg = "لوكسمبورج";
var Macao = "ماكاو";
var Madagascar = "مدغشقر";
var Malawi = "مالاوي";
var Malaysia = "ماليزيا";
var Maldives = "جزر المالديف";
var Mali = "مالي";
var Malta = "مالطا";
var Martinique = "مارتينيك";
var Mauritania = "موريتانيا";
var Mauritius = "موريشيوس";
var Mayotte = "مايوت";
var Mexico = "المكسيك";
var Monaco = "موناكو";
var Mongolia = "منغوليا";
var Montenegro = "مونتنجرو";
var Montserrat = "مونتسيرات";
var Morocco = "المغرب";
var Mozambique = "موزمبيق";
var Myanmar = "ميانمار";
var Namibia = "ناميبيا";
var Nauru = "ناورو";
var Nepal = "نيبال";
var Netherlands = "هولندا";
var Nicaragua = "نيكاراجوا";
var Niger = "النيجر";
var Nigeria = "نيجيريا";
var Niue = "نييوي";
var Norway = "النرويج";
var Oman = "عمان";
var Pakistan = "باكستان";
var Palau = "بالاو";
var Panama = "بنما";
var Paraguay = "باراجواي";
var Peru = "بيرو";
var Philippines = "الفلبين";
var Pitcairn = "بيتكيرن";
var Poland = "بولندا";
var Portugal = "البرتغال";
var Qatar = "قطر";
var Romania = "رومانيا";
var Rwanda = "رواندا";
var Samoa = "ساموا";
var Senegal = "السنغال";
var Serbia = "صربيا";
var Seychelles = "سيشل";
var Singapore = "سنغافورة";
var Slovakia = "سلوفاكيا";
var Slovenia = "سلوفينيا";
var Somalia = "الصومال";
var Spain = "إسبانيا";
var Sudan = "السودان";
var Suriname = "سورينام";
var Swaziland = "سوازيلاند";
var Sweden = "السويد";
var Switzerland = "سويسرا";
var Taiwan = "تايوان";
var Tajikistan = "طاجيكستان";
var Thailand = "تايلاند";
var Togo = "توجو";
var Tokelau = "توكيلاو";
var Tonga = "تونغا";
var Tunisia = "تونس";
var Turkey = "تركيا";
var Turkmenistan = "تركمانستان";
var Tuvalu = "توفالو";
var Uganda = "أوغندا";
var Ukraine = "أوكرانيا";
var Uruguay = "أوروجواي";
var Uzbekistan = "أوزبكستان";
var Vanuatu = "فانواتو";
var Venezuela = "فنزويلا";
var Yemen = "اليمن";
var Zambia = "زامبيا";
var Zimbabwe = "زيمبابوي";
var countries = {
	"Country or region": "البلد أو المنطقة",
	"United States": "الولايات المتحدة",
	Afghanistan: Afghanistan,
	"Åland Islands": "جزر آلاند",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "ساموا الأمريكية",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "أنتيغوا وبربودا",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "البوسنة والهرسك",
	Botswana: Botswana,
	"Bouvet Island": "جزيرة بوفيه‏",
	Brazil: Brazil,
	"British Indian Ocean Territory": "إقليم المحيط الهندي البريطاني",
	"Brunei Darussalam": "بروناي دار السلام",
	Bulgaria: Bulgaria,
	"Burkina Faso": "بوركينا فاسو",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "الرأس الأخضر",
	"Cayman Islands": "جزر كايمان",
	"Central African Republic": "جمهورية إفريقيا الوسطى",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "جزيرة الكريسماس",
	"Cocos (Keeling) Islands": "جزر كوكوس (كيلينغ)",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "جمهورية الكونغو الديمقراطية",
	"Cook Islands": "جزر كوك",
	"Costa Rica": "كوستاريكا",
	"Côte d'Ivoire": "كوت ديفوار",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "جمهورية التشيك",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "جمهورية الدومينيكان",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "السلفادور",
	"Equatorial Guinea": "غينيا الإستوائية",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "جزر فوكلاند (مالفيناس)",
	"Faroe Islands": "جزر فارو",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "غويانا الفرنسية",
	"French Polynesia": "بولينزيا الفرنسية",
	"French Southern Territories": "الأراضي الجنوبية الفرنسية",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "غينيا بيساو",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "جزيرة هيرد وجزر ماكدونالد",
	"Holy See (Vatican City State)": "الكرسي الرسولي (دولة الفاتيكان)",
	Honduras: Honduras,
	"Hong Kong": "هونج كونج",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "جمهورية إيران الإسلامية",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "جزيرة مان",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "جمهورية كوريا الديمقراطية الشعبية",
	"Korea, Republic of": "جمهورية كوريا",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "جمهورية لاوس الديمقراطية الشعبية",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "مقدونيا، جمهورية يوغوسلافيا السابقة",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "جزر مارشال",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "ولايات مايكرونزيا المتحدة",
	"Moldova, Republic of": "جمهورية مولدوفا",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "جزر الأنتيل الهولندية",
	"New Caledonia": "كاليدونيا الجديدة",
	"New Zealand": "نيوزيلندا",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "جزيرة نورفولك",
	"Northern Mariana Islands": "جزر ماريانا الشمالية",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "الأراضي الفلسطينية المحتلة",
	Panama: Panama,
	"Papua New Guinea": "بابوا غينيا الجديدة",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "بورتوريكو",
	Qatar: Qatar,
	"Réunion": "لا ريونيون",
	Romania: Romania,
	"Russian Federation": "الاتحاد الروسي",
	Rwanda: Rwanda,
	"Saint Helena": "سانت هيلينا",
	"Saint Kitts and Nevis": "سانت كيتس ونيفيس",
	"Saint Lucia": "سانت لوسيا",
	"Saint Pierre and Miquelon": "سان بيير وميكلون",
	"Saint Vincent and The Grenadines": "سانت فينسنت والغرينادين",
	Samoa: Samoa,
	"San Marino": "سان مارينو",
	"Sao Tome and Principe": "ساو تومي وبرينسيبي",
	"Saudi Arabia": "السعودية",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "سيراليون",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "جزر سليمان",
	Somalia: Somalia,
	"South Africa": "جنوب أفريقيا",
	"South Georgia and The South Sandwich Islands": "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
	Spain: Spain,
	"Sri Lanka": "سيريلانكا",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "سفالبارد ويان ماين",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "الجمهورية العربية السورية",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "جمهورية تنزانيا الاتحادية",
	Thailand: Thailand,
	"Timor-Leste": "تيمور الشرقية",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "ترينداد وتوباجو",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "جزر تركس وكايكوس",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "الإمارات العربية المتحدة",
	"United Kingdom": "المملكة المتحدة",
	"United States Minor Outlying Islands": "جزر الولايات المتحدة الصغيرة النائية",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "فيتنام",
	"Virgin Islands, British": "جزر فيرجن البريطانية",
	"Virgin Islands, U.S.": "جزر فيرجن الأمريكية",
	"Wallis and Futuna": "واليس وفوتونا",
	"Western Sahara": "الصحراء الغربية",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
